function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#2276E3",
  d: "M9.333 6a.667.667 0 001.334 0V2.21a.167.167 0 01.263-.134l2.933 2.093a.334.334 0 01.137.27v1.56A.666.666 0 1015.333 6V4.095c0-.323-.156-.626-.418-.814L10.582.187a.995.995 0 00-1.163 0L5.552 2.949a.333.333 0 01-.4-.007L1.618.214A1.002 1.002 0 00.563.1 1.002 1.002 0 000 1v9.924c0 .314.149.61.4.8l4.338 3.254a1 1 0 001.18.013l2.917-2.084a.666.666 0 00-.774-1.084l-1.794 1.284a.166.166 0 01-.172.012.167.167 0 01-.092-.145V4.438c0-.108.052-.209.14-.271l2.933-2.093a.167.167 0 01.263.133L9.333 6zm-4.666 6.924c0 .063-.036.12-.092.149a.168.168 0 01-.175-.016l-2.933-2.2a.334.334 0 01-.134-.266V2.018c0-.063.036-.12.092-.15a.17.17 0 01.175.017L4.533 4.15a.334.334 0 01.134.267v8.506z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FF3A5C",
  d: "M12.667 7.333a3.339 3.339 0 00-3.334 3.334c0 2.114 2.972 5.109 3.098 5.236a.335.335 0 00.472 0c.126-.127 3.097-3.122 3.097-5.236a3.337 3.337 0 00-3.333-3.334zm0 4.5a1.166 1.166 0 11-.002-2.332 1.166 1.166 0 01.002 2.332z"
}));

function SvgLocationInfoIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16
  }, props), _ref);
}

export default SvgLocationInfoIcon;